// Shared "walking cat" loading animation, used everywhere the app is loading.
// Prefers this environment's static container, falling back to the dev container
// (the clip is guaranteed to exist there) if it isn't present.
const CAT_PRIMARY = `${process.env.REACT_APP_STATIC_STORAGE_URL || ''}/images/catwalking-small.mp4`;
const CAT_FALLBACK = 'https://videoostatic.blob.core.windows.net/developmentstatic/images/catwalking-small.mp4';

export const WalkingCatLoader = ({ size = 70 }) => {
  const handleError = (e) => {
    if (e.currentTarget.src !== CAT_FALLBACK) e.currentTarget.src = CAT_FALLBACK;
  };
  return (
    <video
      src={CAT_PRIMARY}
      onError={handleError}
      autoPlay
      loop
      muted
      playsInline
      aria-label="Loading"
      style={{ width: size, height: 'auto', display: 'block', margin: '0 auto' }}
    />
  );
};

export default WalkingCatLoader;
